import request, { IServerResponse } from '@/utils/request';

import { FormValueType } from '../components/BillList/SubmitInvoiceModal';
import {
    IGetBillDetail,
    IGetBalanceDetail,
    ITimeReq,
    ITimeReqV2,
    PageReq,
    IGetBalanceType,
    PageReqV2,
    IGetBillType,
    IGetProvinceType,
    IGetCityType,
    IGetReceiptAddress,
} from './define';

// 服务商查询账户余额
export const getAccountBalance = (): Promise<IServerResponse<string>> =>
    request.get('/api/thirdpartnar/account/balance');

// 获取发票详情
export const getInvoiceList = (payBillId: string): Promise<IServerResponse<IGetBillDetail[]>> =>
    request.get('/api/thirdpartnar/bill/invoice/list', { payBillId });

// 发起账单明细下载任务
export const getDownLoadTask = (params: ITimeReqV2): Promise<IServerResponse<string>> =>
    request.get('/api/thirdpartnar/bill/download/submit', params);

// 获取账单明细列表页数
export const getBillDownLoadListCount = (): Promise<IServerResponse<number>> =>
    request.get('/api/thirdpartnar/bill/download/count');

// 获取账单明细列表
export const getBillDownLoadList = (
    params: PageReq,
): Promise<IServerResponse<IGetBalanceDetail[]>> =>
    request.get('/api/thirdpartnar/bill/download/linkList', params);

// 查询周期余额流水列表
export const getBalanceList = (
    params: PageReqV2 & ITimeReq,
): Promise<IServerResponse<IGetBalanceType[]>> =>
    request.get('/api/thirdpartnar/account/statement', params);

// 查询余额流水记录总数（分页使用）
export const getBalanceListCount = (
    params: PageReqV2 & ITimeReq,
): Promise<IServerResponse<number>> =>
    request.get('/api/thirdpartnar/account/statementCount', params);

// 查询周期账单列表
// eslint-disable-next-line max-len
export const getBillList = (
    params: PageReq & ITimeReq,
): Promise<IServerResponse<IGetBillType[] | null>> =>
    request.get('/api/thirdpartnar/bill/list', params);

// 查询周期账单总数
export const getBillCount = (params: PageReq & ITimeReq): Promise<IServerResponse<string>> =>
    request.get('/api/thirdpartnar/bill/count', params);

// 获取省份列表
export const getProvinceList = (): Promise<IServerResponse<IGetProvinceType[]>> =>
    request.get('/api/city/provinceList');

// 获取当前省份城市列表
export const getSubCity = (cityId: number): Promise<IServerResponse<IGetCityType[]>> =>
    request.post('/api/city/subCityInfo/get', { cityIds: [cityId] });

//  上传发票列表信息
export const postInvoiceUpload = (params: FormValueType): Promise<IServerResponse<string>> =>
    request.post('/api/thirdpartnar/bill/invoice/upload', params, {
        headers: { 'Content-Type': 'application/json' },
    });

//  查询发票地址信息
export const getReceiptAddress = (): Promise<IServerResponse<IGetReceiptAddress>> =>
    request.get('/api/thirdpartnar/bill/invoice/receiptAddress');
